import { getRequestContext } from './server/request-context';

export function useCurrentCurrency() {
  // This is not a real hook but it cannot be used in initial script on server
  return __BROWSER__
    ? window.INITIAL_DATA.currentCurrency
    : getRequestContext().initialData!.clientData.currentCurrency!;
}

export function useCurrentLanguage() {
  // This is not a real hook but it cannot be used in initial script on server
  return __BROWSER__
    ? window.INITIAL_DATA.currentLanguage
    : getRequestContext().initialData!.clientData.currentLanguage!;
}

export function useCurrentCountry() {
  // This is not a real hook but it cannot be used in initial script on server
  return __BROWSER__ ? window.INITIAL_DATA.currentCountry : getRequestContext().initialData!.clientData.currentCountry!;
}
